/**
 *
 * RenderPopconfirm
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Popconfirm } from 'antd';

function RenderPopconfirm({
  showPopup,
  placement,
  message,
  title,
  okText,
  cancelText,
  // actions
  onCancel,
  onConfirm,
  // default props
  className,
  children,
}) {
  const childClassNames = classNames(
    'render-tab-title-wrapper',
    'popconfirm-window',
    className,
  );

  return showPopup ? (
    <Popconfirm
      placement={placement}
      title={message}
      onCancel={onCancel}
      onConfirm={onConfirm}
      okText={okText}
      cancelText={cancelText}
      overlayClassName={childClassNames}
    >
      {title || children}
    </Popconfirm>
  ) : (
    title || children
  );
}

RenderPopconfirm.defaultProps = {
  placement: 'top',
  message: 'Voulez-vous enregistrer les modifications.',
  okText: 'Oui',
  cancelText: 'Non',
  showPopup: false,
};
RenderPopconfirm.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default memo(RenderPopconfirm);
